import React from "react";
import { getLabel } from "../../../data/labels";
import { formatDate, getConfiguration, getCurrencyValue, isCoinAmount } from "../../utils";
import ShopReceiptHeader from "./common-includes/ShopReceiptHeader";

function TransactionsLog(props){
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    const transactionsData = props.data;
    
    const additionalStyle = {
        "fontFamily" : "sans-serif",
        "fontSize" : "19px"
    };

    const transactions = transactionsData.map((t,i)=>{
      
        return  <tr key={i} >
                    <td style={{textAlign:'center',fontSize:'10px'}} >{ formatDate(t.dataOra).formatted}</td>
                    <td style={{textAlign:'center',fontSize:'10px'}}>{isCoinAmount(t.importo)?'M':'B'}</td>
                    <td style={{textAlign:'right', fontSize:'10px'}}>{getCurrencyValue( t.importo, mult, nDec, currency)}</td>
                </tr>
    })

    return (
        <body style={additionalStyle}>
            <ShopReceiptHeader operationTitle={getLabel('retail.transactions_log')}></ShopReceiptHeader>
            <table className="width50x50">
                <thead>
                    
                    <tr>
                        <th>Timestamp</th>
                        <th>Tipo</th>
                        <th>Importo</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions}
                </tbody>
            </table>
        </body>
    )
}

export default TransactionsLog;